import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class OrderSendListButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
        const { showNotification, selectedIds = [], refreshView } = this.props;

        this.setState({
          executing: true
        });
        let data = {
        }
        if (selectedIds && selectedIds.length > 0) {
          data.ids = selectedIds.join(',')
        }
        let response = null;
        try {
          response = await request({
            apiService: 'shoes',
            path: '/admin/order/func/send/list',
            urlParams: data,
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.orderSendList.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.orderSendList.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        return (
            <Button label={`resources.${resourceConfig.name}.orderSendList.action`} disabled={this.state.executing} onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { 
  showNotification,
  refreshView: refreshViewAction
})(OrderSendListButton);